<template lang="pug">
  .prepaid.w-65-d.mx-auto
    //- .overlay(v-show="overlay")
    v-dialog(v-model="modalPrepaid", max-width="450px", persistent)
      v-card.prepaid-modal.pt-4.px-4.pb-5
        v-card-text
          h2.omnesMedium.text-xs-center.mb-4 ¿Cómo funciona?
          v-layout(v-for="itemModal in  itemsModalPrepaid", :key="itemModal.id").mt-3.pb-3
            v-flex(xs1).mt-1
              .circle-blue
                span {{ itemModal.id }}
            v-flex(xs11)
              .pl-3(v-html="itemModal.descrip")
          v-layout.mt-5
            v-btn.btn-purple.btn-empezar.mx-auto.px-5(@click="closeModalPrepaid") ¡Quiero empezar!
    v-container
      //pagina 3
      section(v-show="page3")
        h2.mb-2.omnesMedium.text-xs-center Selecciona el préstamo que deseas prepagar
        v-layout.wrap-m.g-justify-lg-between.prepaid-table(wrap row)
          v-flex(:class="{'mx-d': oneColumnTable, 'md7': oneColumnTable, 'md6': columnsTable}", v-for="item in dataTablePage3", :key="item.id").mt-3.prepaid-table-column.w-full-m.px1-d
            .style-table.transition-all-3.cursor-pointer(:class="{'border-2-gray-light': item.inactive, 'border-2-blue': item.active}", @click="activeTablePage3(item)")
              v-layout(align-center, :class="{'bg-gray-light': item.inactive, 'bg-blue': item.active}").py-2
                .prepaid-table-header(:class="{'active-header-table': item.active}")
                  .prepaid-table-header-column-1
                    .style-table-circle(:class="{'bg-gray-light': item.inactive, 'bg-blue': item.active}")
                      v-icon(v-show="item.check") check
                  .prepaid-table-header-column-2
                    div
                      p.white--text Nombre del producto:
                      p.font-weight-bold.white--text {{ item.nameProduct }}
                    div
                      p.white--text N° de póliza
                      p.font-weight-bold.white--text {{ item.policyNumber }}

              .px-3.pb-4
                v-layout(align-center).style-table-title.mb-2.py-2
                  v-flex(xs8)
                    h4.font-weight-bold Monto del préstamo
                  v-flex(xs4)
                    h4.font-weight-bold
                      span {{item.loanAmount}}

                v-layout(align-center).my-1
                  v-flex(xs8)
                    p Fecha de solicitud:
                  v-flex(xs4)
                    p.font-weight-bold {{item.disbursementDate}}
                v-layout(align-center).my-1
                  v-flex(xs8)
                    p Código de préstamo:
                  v-flex(xs4)
                    p.font-weight-bold {{item.numberLoan}}
                v-layout(align-center).my-1.prepaid-table-row-poliza
                  v-flex(xs8)
                    p.font-weight-bold Número de la poliza:
                  v-flex(xs4)
                    p {{ item.policyNumber }}
        v-layout.mt-5
          v-btn(:disabled="disabledSgtePage3", @click="viewProcess").btn-purple.btn-sgte.mx-auto.px-5 Siguiente
    //- LOADER PROCESS
    v-dialog(v-model="validateLoader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Validando prepagos existentes...
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      prepaidProces: 1,
      modalPrepaid: true,
      validateLoader: false,
      itemsModalPrepaid: [
        {
          id: 1,
          descrip: '<p style="margin-top:3px;">Simula tu prepago</p>'
        },
        {
          id: 2,
          descrip: '<p>Ten la disposición de tiempo para acercarte a un banco o a la banca por internet/app de tu banco dentro de las próximas horas</p>'
        },
        {
          id: 3,
          descrip: '<p><strong>¡Listo!</strong> Te confirmaremos por correo electrónico cuando hayamos recibido el prepago</p>'
        }

      ],
      dataTablePage3: [],
      overlay: true,
      disabledSgtePage3: true,
      page3: true,
      oneColumnTable: false,
      columnsTable: false,
      trackEvents: {
        access: {
          category: 'Prepagos',
          action: 'Acceso',
          label: 'Acceso OK',
          event: 'PREPAGO Acceso'
        },
        simulator: {
          category: 'Prepagos',
          action: 'Acceso',
          label: 'Simulador de prepago',
          event: 'PREPAGO Simulado'
        },
        prepaidOrdered: {
          category: 'Prepagos',
          action: 'Acceso',
          label: 'Prepago orden generada',
          event: 'PREPAGO Orden generada'
        },
        prepaidRejected: {
          category: 'Prepagos',
          action: 'Rechazo',
          label: 'Prepago pendiente por pagar',
          event: 'PREPAGO Pendiente por pagar'
        },
        prepaidFound: {
          category: 'Prepagos',
          action: 'Rechazo',
          label: 'Prepago no disponible',
          event: 'PREPAGO Pagado existente'
        },
        error: {
          category: 'Prepagos',
          action: 'Error',
          label: 'Error de Servidor',
          event: 'PREPAGO Server Error'
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['getPrestamosActivos', 'verifyAvailablePrepago']),
    activeTablePage3 (item) {
      this.dataTablePage3.forEach((v) => {
        v.active = false
        v.check = false
        v.inactive = true
      })

      item.active = true
      item.check = true
      item.inactive = false
      this.disabledSgtePage3 = false
    },
    closeModalPrepaid () {
      this.overlay = false
      this.modalPrepaid = false
    },
    viewProcess () {
      let self = this
      self.validateLoader = true
      let dataActive = this.dataTablePage3.filter((v) => { return v.active === true })
      self.verifyAvailablePrepago({ codigoPrestamo: dataActive[0].numberLoan })
        .then(res => {
          self.validateLoader = false
          if (res.data.status) {
            self.$router.push({ name: 'PrepaidProcess', params: { numeroPoliza: dataActive[0].policyNumber, codigoPrestamo: dataActive[0].numberLoan } })
          } else if (!res.data.status && res.data.prepagoPendiente) {
            self.trackEvents.prepaidRejected.producto = dataActive[0].nameProduct
            self.$gtm.trackEvent(self.trackEvents.prepaidRejected)
            self.$swal({
              title: 'Estimado Cliente',
              text: 'Tiene el prepago ' + res.data.prepagoPendiente + ' pendiente de pago para este préstamo. Podrá solicitar uno nuevo al día siguiente.',
              type: 'info',
              confirmButtonText: 'Entendido'
            })
          } else if (!res.data.status && res.data.prepagoConciliado) {
            self.trackEvents.prepaidFound.producto = dataActive[0].nameProduct
            self.$gtm.trackEvent(self.trackEvents.prepaidFound)
            self.$swal({
              title: 'Estimado Cliente',
              text: 'Ya efectuó el pago del prepago ' + res.data.prepagoConciliado + '. Podrá solicitar uno nuevo el mes siguiente.',
              type: 'info',
              confirmButtonText: 'Entendido'
            })
          }
        })
        .catch(() => {
          self.trackEvents.error.producto = dataActive[0].nameProduct
          self.$gtm.trackEvent(self.trackEvents.error)
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Tenemos un inconveniente en los sistema. Puede intentar solicitar su prepago luego de unos minutos. Gracias por la comprensión.',
            type: 'info',
            confirmButtonText: 'Entendido'
          }).then((result) => {
            self.$router.push('/')
          })
        })
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo', 'functionsRules'])
  },
  mounted () {
    let self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PREPAGOS, self.functionsRules, self)) {
      self.modalPrepaid = false
      self.$router.push('/inicio')
      return
    }
    self.$gtm.trackEvent(self.trackEvents.access)
    this.getPrestamosActivos({ tipoDocumento: this.basicInfo.tipoDocumento === 'DNI' ? 'D' : 'C', numeroDocumento: this.basicInfo.numeroDocumento })
      .then((res) => {
        let prestamos = res.data.prestamos
        for (let index = 0; index < prestamos.length; index++) {
          if (prestamos.length <= 1) {
            this.oneColumnTable = true
          }

          this.columnsTable = true
          let table = {
            id: index + 1,
            active: false,
            check: false,
            inactive: true,
            policyNumber: prestamos[index].numeroPoliza,
            loanAmount: prestamos[index].montoPrestamo,
            nameProduct: prestamos[index].producto,
            disbursementDate: prestamos[index].fechaSolicitud.split('-').join('/'),
            numberLoan: prestamos[index].codigoPrestamo
          }
          this.dataTablePage3.push(table)
        }
      })
  }
}

</script>
<style>
  @import url('../../assets/css/general.css');

  .prepaid h2 {
    font-size: 22px;
    margin: auto;
    width:80%;
  }
  .btn-empezar {
    width: 210px!important;
  }
  .btn-sgte {
    width: 200px!important;
  }
  .prepaid-table-header {
    padding: 0 5px;
    width: 100%;
  }
  .prepaid-table-header-column-2 div {
    display: flex;
  }
  .prepaid-table-header-column-2 div p {
    font-size: 14px!important;
  }
  .style-table .px-3 .style-table-title .xs4,
  .style-table .px-3 .my-1 .xs4 {
    text-align: right;
  }
  @media screen and (max-width: 420px) {
    .prepaid-table-header-column-2 div p:nth-of-type(1) {
      width: 52%;
    }
    .prepaid-table-header-column-2 div p:nth-of-type(2) {
      width: 48%;
    }
  }
  @media only screen and (max-width: 600px) {
    .prepaid h2 {
      margin-top: 3em;
      width: 70%;
    }
  }
  @media screen and (min-width: 421px) and (max-width: 960px) {
    .prepaid-table-header-column-2 div p:nth-of-type(1) {
      width: 66%;
    }
    .prepaid-table-header {
      padding: 0 14px;
    }
    .prepaid-table-header-column-2 div p:nth-of-type(2) {
      width: 33%;
      text-align: right;
    }
  }
  @media screen and (max-width: 959px) {
    .prepaid-table-header-column-1 {
      display: none;
    }
  }
  @media screen and (max-width: 960px) {
    .prepaid-table {
      margin-left: auto;
      margin-right: auto;
      max-width: 500px;
      width: 100%;
    }
  }
  @media screen and (min-width: 960px) {
    .prepaid h2 {
      font-size: 27px;
    }
    .prepaid-table-row-poliza {
      display: none;
    }
    .prepaid-table-header,
    .prepaid-table-header-column-2 {
      display:flex;
    }
    .prepaid-table-header {
      align-items: center;
    }
    .prepaid-table-header-column-2 div {
      flex-wrap: wrap;
      flex-direction: row;
    }
    .prepaid-table-header-column-1 {
      padding-left: 10px;
    }
    .prepaid-table-header-column-2 {
      padding-right: 10px;
    }
    .prepaid-table-header-column-2 div:nth-child(2) {
      display: flex;
      justify-content: flex-end;
    }
    .prepaid-table-header-column-2 div:nth-child(1) p,
    .prepaid-table-header-column-2 div:nth-child(2) p {
      font-size: 16px!important;
    }
    .prepaid-table-header-column-2 div:nth-child(1) p:nth-child(1),
    .prepaid-table-header-column-2 div:nth-child(1) p:nth-child(2) {
      margin-left: 15px;
    }
    .btn-empezar {
      width: 230px!important;
    }
    .px1-d {
      padding-left: 0.75em;
      padding-right: 0.75em;
    }
    .mx-d {
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media screen and (max-width: 991px) {
    .prepaid {
      width: 100%;
    }
  }
  @media screen and (min-width: 1265px) {
      section.prepaid .prepaid-table .prepaid-table-column {
      flex-basis: 49%;
      flex-grow: 0;
      max-width: 49%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Prepaids/Index.vue